import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MeuFaturamentoComponent } from './meu-faturamento.component';

const routes: Routes = [
  {
    path: 'faturamento/:contaId',
    component: MeuFaturamentoComponent,
    data: { title: 'Faturamento' }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class MeuFaturamentoRoutingModule { }
